// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "./node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./src/assets/font/Poppins-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./src/assets/font/Poppins-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./src/assets/font/Poppins-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./src/assets/font/YekanBakhFaNum-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./src/assets/font/YekanBakhFaNum-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./src/assets/font/YekanBakhFaNum-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.16 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

:root {
  --css-interop-darkMode: class dark;
  --css-interop: true;
  --css-interop-nativewind: true;
}
  /* Poppins Font Family */
  @font-face {
    font-family: 'Poppins-Regular';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  @font-face {
    font-family: 'Poppins-Bold';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
  @font-face {
    font-family: 'Poppins-SemiBold';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }

  /* YekanBakhFaNum Font Family */
  @font-face {
    font-family: 'YekanBakhFaNum-Regular';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }
  @font-face {
    font-family: 'YekanBakhFaNum-Bold';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  }
  @font-face {
    font-family: 'YekanBakhFaNum-SemiBold';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  }
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.Container {
  width: 100%;
  max-width: 450px;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.CardBase {
  gap: 0.75rem;
  border-radius: 1.5rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
  background-color: rgb(255 255 255 / 0.4);
  padding: 1rem;
  --tw-shadow: 4px 4px 10px rgba(0,0,0,0.05);
  --tw-shadow-colored: 4px 4px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.CardBase:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(42 45 51 / var(--tw-border-opacity, 1));
  background-color: rgb(42 45 51 / 0.4);
}
.GiftCard {
  gap: 0.75rem;
  border-radius: 1.5rem;
  border-width: 1px;
  border-color: rgb(178 139 201 / 0.6);
  background-color: rgb(178 139 201 / 0.2);
  padding: 1rem;
  --tw-shadow: 4px 4px 10px rgba(0,0,0,0.05);
  --tw-shadow-colored: 4px 4px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
/* Primary */
.Fill-Primary {
  border-width: 2px;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(188 220 100 / var(--tw-bg-opacity, 1));
}
.Fill-Primary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(201 228 131 / var(--tw-bg-opacity, 1));
}
.Tonal-Primary {
  border-width: 2px;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(224 239 184 / var(--tw-bg-opacity, 1));
}
.Tonal-Primary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(234 244 207 / var(--tw-bg-opacity, 1));
}
.Tonal-Primary:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(103 124 55 / var(--tw-bg-opacity, 1));
}
.Tonal-Primary:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(79 93 42 / var(--tw-bg-opacity, 1));
}
.Outline-Primary {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(188 220 100 / var(--tw-border-opacity, 1));
  background-color: transparent;
}
.Outline-Primary:hover {
  --tw-border-opacity: 1;
  border-color: rgb(201 228 131 / var(--tw-border-opacity, 1));
}
.TextButton-Primary {
  border-width: 1px;
  border-color: transparent;
  background-color: transparent;
}
/* Black */
.Fill-Black {
  border-width: 2px;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(27 29 33 / var(--tw-bg-opacity, 1));
}
.Fill-Black:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(35 37 41 / var(--tw-bg-opacity, 1));
}
.Fill-Black:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));
}
.Fill-Black:is(.dark *):hover {
  --tw-bg-opacity: 1;
  background-color: rgb(234 234 235 / var(--tw-bg-opacity, 1));
}
.Fill-Supportive1-Yellow {
  border-width: 2px;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(254 211 118 / var(--tw-bg-opacity, 1));
}
.Fill-Supportive1-Yellow:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 220 145 / var(--tw-bg-opacity, 1));
}
.Fill-Supportive1-Yellow:is(.dark *):hover {
  --tw-bg-opacity: 1;
  background-color: rgb(231 192 107 / var(--tw-bg-opacity, 1));
}
.Fill-Supportive5-Blue {
  border-width: 2px;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(91 200 255 / var(--tw-bg-opacity, 1));
}
.Fill-Supportive5-Blue:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(124 211 255 / var(--tw-bg-opacity, 1));
}
.Fill-Supportive5-Blue:is(.dark *):hover {
  --tw-bg-opacity: 1;
  background-color: rgb(83 182 232 / var(--tw-bg-opacity, 1));
}
.Tonal-Black {
  border-width: 2px;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 232 / var(--tw-bg-opacity, 1));
}
.Tonal-Black:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));
}
.Tonal-Black:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(35 37 41 / var(--tw-bg-opacity, 1));
}
.Tonal-Black:is(.dark *):hover {
  --tw-bg-opacity: 1;
  background-color: rgb(27 29 33 / var(--tw-bg-opacity, 1));
}
.Outline-Black {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(27 29 33 / var(--tw-border-opacity, 1));
  background-color: transparent;
}
.Outline-Black:hover {
  --tw-border-opacity: 1;
  border-color: rgb(35 37 41 / var(--tw-border-opacity, 1));
}
.Outline-Black:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(244 244 245 / var(--tw-border-opacity, 1));
}
.Outline-Black:is(.dark *):hover {
  --tw-border-opacity: 1;
  border-color: rgb(234 234 235 / var(--tw-border-opacity, 1));
}
.TextButton-Black {
  border-width: 1px;
  border-color: transparent;
  background-color: transparent;
}
/* Success */
.Fill-Success {
  border-width: 2px;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(55 201 118 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.Fill-Success:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(95 212 145 / var(--tw-bg-opacity, 1));
}
.Fill-Success:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(22 24 27 / var(--tw-text-opacity, 1));
}
.Tonal-Success {
  border-width: 2px;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(193 238 213 / var(--tw-bg-opacity, 1));
}
.Tonal-Success:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(235 250 241 / var(--tw-bg-opacity, 1));
}
.Tonal-Success:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(23 84 50 / var(--tw-bg-opacity, 1));
}
.Tonal-Success:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(18 70 41 / var(--tw-bg-opacity, 1));
}
.Outline-Success {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(55 201 118 / var(--tw-border-opacity, 1));
  background-color: transparent;
}
.Outline-Success:hover {
  --tw-border-opacity: 1;
  border-color: rgb(95 212 145 / var(--tw-border-opacity, 1));
}
.TextButton-Success {
  border-width: 1px;
  border-color: transparent;
  background-color: transparent;
}
.BaseServiceCard {
  width: 100%;
  min-width: 320px;
  border-radius: 1.5rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
  background-color: rgb(255 255 255 / 0.5);
  padding: 1rem;
}
.BaseServiceCard:is(.dark *) {
  border-color: rgb(85 87 92 / 0.5);
  background-color: rgb(42 45 51 / 0.5);
}
.Outline-Supportive5-Blue {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(91 200 255 / var(--tw-border-opacity, 1));
  background-color: transparent;
}
.Outline-Supportive5-Blue:hover {
  --tw-border-opacity: 1;
  border-color: rgb(124 211 255 / var(--tw-border-opacity, 1));
}
.\\!visible {
  visibility: visible !important;
}
.visible {
  visibility: visible;
}
.collapse {
  visibility: collapse;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.-bottom-0\\.5 {
  bottom: -0.125rem;
}
.-bottom-10 {
  bottom: -2.5rem;
}
.-bottom-\\[150px\\] {
  bottom: -150px;
}
.-bottom-\\[70px\\] {
  bottom: -70px;
}
.-left-0\\.5 {
  left: -0.125rem;
}
.-left-\\[64\\%\\] {
  left: -64%;
}
.-left-\\[7px\\] {
  left: -7px;
}
.-left-\\[8px\\] {
  left: -8px;
}
.-right-0\\.5 {
  right: -0.125rem;
}
.-right-1 {
  right: -0.25rem;
}
.-right-\\[2\\.5px\\] {
  right: -2.5px;
}
.-right-\\[64\\%\\] {
  right: -64%;
}
.-right-\\[7px\\] {
  right: -7px;
}
.-right-\\[8px\\] {
  right: -8px;
}
.-top-0\\.5 {
  top: -0.125rem;
}
.-top-1 {
  top: -0.25rem;
}
.-top-16 {
  top: -4rem;
}
.-top-4 {
  top: -1rem;
}
.-top-\\[0\\%\\] {
  top: -0%;
}
.-top-\\[100\\%\\] {
  top: -100%;
}
.-top-\\[125\\%\\] {
  top: -125%;
}
.-top-\\[20\\%\\] {
  top: -20%;
}
.-top-\\[20px\\] {
  top: -20px;
}
.-top-\\[22px\\] {
  top: -22px;
}
.-top-\\[25\\%\\] {
  top: -25%;
}
.-top-\\[28\\%\\] {
  top: -28%;
}
.-top-\\[70px\\] {
  top: -70px;
}
.-top-\\[7px\\] {
  top: -7px;
}
.-top-\\[8px\\] {
  top: -8px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-32 {
  bottom: 8rem;
}
.bottom-7 {
  bottom: 1.75rem;
}
.bottom-\\[-85px\\] {
  bottom: -85px;
}
.left-0 {
  left: 0px;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-4 {
  left: 1rem;
}
.left-\\[12px\\] {
  left: 12px;
}
.left-\\[18px\\] {
  left: 18px;
}
.left-\\[20\\%\\] {
  left: 20%;
}
.left-\\[30\\%\\] {
  left: 30%;
}
.left-\\[36px\\] {
  left: 36px;
}
.left-\\[45px\\] {
  left: 45px;
}
.left-\\[6\\%\\] {
  left: 6%;
}
.left-\\[64\\%\\] {
  left: 64%;
}
.left-\\[9px\\] {
  left: 9px;
}
.right-0 {
  right: 0px;
}
.right-2 {
  right: 0.5rem;
}
.right-4 {
  right: 1rem;
}
.right-\\[12px\\] {
  right: 12px;
}
.right-\\[18px\\] {
  right: 18px;
}
.right-\\[80\\%\\] {
  right: 80%;
}
.right-\\[9px\\] {
  right: 9px;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-2 {
  top: 0.5rem;
}
.top-3 {
  top: 0.75rem;
}
.top-4 {
  top: 1rem;
}
.top-\\[-28px\\] {
  top: -28px;
}
.top-\\[-95px\\] {
  top: -95px;
}
.top-\\[12px\\] {
  top: 12px;
}
.top-\\[2px\\] {
  top: 2px;
}
.top-\\[3\\.2px\\] {
  top: 3.2px;
}
.top-\\[9px\\] {
  top: 9px;
}
.\\!z-50 {
  z-index: 50 !important;
}
.-z-10 {
  z-index: -10;
}
.-z-\\[1\\] {
  z-index: -1;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-\\[1\\] {
  z-index: 1;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-auto {
  margin-top: auto;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.flex {
  display: flex;
}
.table {
  display: table;
}
.hidden {
  display: none;
}
.aspect-\\[13\\/4\\] {
  aspect-ratio: 13/4;
}
.aspect-\\[4\\/3\\] {
  aspect-ratio: 4/3;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-2 {
  height: 0.5rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-4 {
  height: 1rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[100px\\] {
  height: 100px;
}
.h-\\[125px\\] {
  height: 125px;
}
.h-\\[14px\\] {
  height: 14px;
}
.h-\\[180px\\] {
  height: 180px;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-\\[24px\\] {
  height: 24px;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-\\[32px\\] {
  height: 32px;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[44px\\] {
  height: 44px;
}
.h-\\[45px\\] {
  height: 45px;
}
.h-\\[48px\\] {
  height: 48px;
}
.h-\\[55px\\] {
  height: 55px;
}
.h-\\[56px\\] {
  height: 56px;
}
.h-\\[60\\%\\] {
  height: 60%;
}
.h-\\[600px\\] {
  height: 600px;
}
.h-\\[61px\\] {
  height: 61px;
}
.h-\\[70px\\] {
  height: 70px;
}
.h-\\[80px\\] {
  height: 80px;
}
.h-\\[95px\\] {
  height: 95px;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.min-h-\\[100px\\] {
  min-height: 100px;
}
.min-h-\\[400px\\] {
  min-height: 400px;
}
.\\!w-fit {
  width: fit-content !important;
}
.\\!w-full {
  width: 100% !important;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-4 {
  width: 1rem;
}
.w-6 {
  width: 1.5rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[185px\\] {
  width: 185px;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[24px\\] {
  width: 24px;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[400px\\] {
  width: 400px;
}
.w-\\[40px\\] {
  width: 40px;
}
.w-\\[44px\\] {
  width: 44px;
}
.w-\\[45px\\] {
  width: 45px;
}
.w-\\[4px\\] {
  width: 4px;
}
.w-\\[56px\\] {
  width: 56px;
}
.w-\\[600px\\] {
  width: 600px;
}
.w-\\[61px\\] {
  width: 61px;
}
.w-\\[88px\\] {
  width: 88px;
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.max-w-\\[130px\\] {
  max-width: 130px;
}
.max-w-\\[140px\\] {
  max-width: 140px;
}
.max-w-\\[160px\\] {
  max-width: 160px;
}
.max-w-\\[180px\\] {
  max-width: 180px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[230px\\] {
  max-width: 230px;
}
.max-w-\\[234px\\] {
  max-width: 234px;
}
.max-w-\\[250px\\] {
  max-width: 250px;
}
.max-w-\\[300px\\] {
  max-width: 300px;
}
.max-w-\\[310px\\] {
  max-width: 310px;
}
.max-w-\\[408px\\] {
  max-width: 408px;
}
.max-w-\\[450px\\] {
  max-width: 450px;
}
.max-w-\\[70\\%\\] {
  max-width: 70%;
}
.max-w-full {
  max-width: 100%;
}
.\\!flex-1 {
  flex: 1 1 0% !important;
}
.flex-1 {
  flex: 1 1 0%;
}
.shrink {
  flex-shrink: 1;
}
.-translate-y-1 {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-12 {
  --tw-rotate: -12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-45 {
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-0 {
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.resize {
  resize: both;
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-16 {
  gap: 4rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-7 {
  gap: 1.75rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-9 {
  gap: 2.25rem;
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-neutral-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(228 228 232 / var(--tw-divide-opacity, 1));
}
.overflow-hidden {
  overflow: hidden;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-nowrap {
  text-wrap: nowrap;
}
.\\!rounded {
  border-radius: 0.25rem !important;
}
.\\!rounded-2xl {
  border-radius: 1rem !important;
}
.\\!rounded-full {
  border-radius: 9999px !important;
}
.\\!rounded-none {
  border-radius: 0px !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[12px\\] {
  border-radius: 12px;
}
.rounded-\\[15px\\] {
  border-radius: 15px;
}
.rounded-\\[16px\\] {
  border-radius: 16px;
}
.rounded-\\[4px\\] {
  border-radius: 4px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b-\\[32px\\] {
  border-bottom-right-radius: 32px;
  border-bottom-left-radius: 32px;
}
.rounded-e-xl {
  border-start-end-radius: 0.75rem;
  border-end-end-radius: 0.75rem;
}
.rounded-s-xl {
  border-start-start-radius: 0.75rem;
  border-end-start-radius: 0.75rem;
}
.rounded-t-3xl {
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}
.\\!border-2 {
  border-width: 2px !important;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-l {
  border-left-width: 1px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-dashed {
  border-style: dashed;
}
.\\!border-error-100 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(254 201 203 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-neutral-400 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(170 171 173 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-neutral-500 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(113 113 129 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-neutral-dark-400 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(85 87 92 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-neutral-dark-500 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(127 129 133 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-primary-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(210 232 151 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-primary-500 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(188 220 100 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-primary-700 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(133 157 71 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-primary-dark-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(133 157 71 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-primary-dark-700 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(210 232 151 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-success-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(121 219 163 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-success-700 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(39 143 84 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-success-dark-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(39 143 84 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-success-dark-700 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(121 219 163 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-supportive1-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(254 226 163 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-supportive1-dark-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(180 150 84 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-supportive5-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(145 218 255 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-supportive5-dark-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(65 142 181 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#F55F56\\] {
  --tw-border-opacity: 1;
  border-color: rgb(245 95 86 / var(--tw-border-opacity, 1));
}
.border-error-500 {
  --tw-border-opacity: 1;
  border-color: rgb(253 80 79 / var(--tw-border-opacity, 1));
}
.border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}
.border-neutral-0 {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-neutral-100 {
  --tw-border-opacity: 1;
  border-color: rgb(244 244 245 / var(--tw-border-opacity, 1));
}
.border-neutral-200 {
  --tw-border-opacity: 1;
  border-color: rgb(228 228 232 / var(--tw-border-opacity, 1));
}
.border-neutral-200\\/40 {
  border-color: rgb(228 228 232 / 0.4);
}
.border-neutral-300 {
  --tw-border-opacity: 1;
  border-color: rgb(212 213 214 / var(--tw-border-opacity, 1));
}
.border-neutral-400 {
  --tw-border-opacity: 1;
  border-color: rgb(170 171 173 / var(--tw-border-opacity, 1));
}
.border-neutral-500\\/40 {
  border-color: rgb(113 113 129 / 0.4);
}
.border-primary-300 {
  --tw-border-opacity: 1;
  border-color: rgb(210 232 151 / var(--tw-border-opacity, 1));
}
.border-primary-500 {
  --tw-border-opacity: 1;
  border-color: rgb(188 220 100 / var(--tw-border-opacity, 1));
}
.border-secondary-500 {
  --tw-border-opacity: 1;
  border-color: rgb(118 118 238 / var(--tw-border-opacity, 1));
}
.border-success-500 {
  --tw-border-opacity: 1;
  border-color: rgb(55 201 118 / var(--tw-border-opacity, 1));
}
.border-supportive2-500\\/60 {
  border-color: rgb(178 139 201 / 0.6);
}
.border-warning-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 145 52 / var(--tw-border-opacity, 1));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.\\!bg-error-600 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(230 73 72 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-neutral-1000 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(22 24 27 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-neutral-300 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(212 213 214 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-neutral-dark-1000 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-neutral-dark-300 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(42 45 51 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-primary-200 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(224 239 184 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-primary-700 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(133 157 71 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-primary-dark-200 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(103 124 55 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-primary-dark-700 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(210 232 151 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-success-200 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(163 230 192 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-success-700 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(39 143 84 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-success-dark-200 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(30 111 65 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-success-dark-700 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(121 219 163 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-supportive1-700 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(180 150 84 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-supportive1-dark-700 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 226 163 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-supportive5-700 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(65 142 181 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-supportive5-dark-700 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(145 218 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#1B1D21\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(27 29 33 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#52C41A\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(82 196 26 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#6E7787\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(110 119 135 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E4E4E8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 232 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F5F5F5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F8F8F9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 248 249 / var(--tw-bg-opacity, 1));
}
.bg-bg-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));
}
.bg-black\\/20 {
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-error-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 201 203 / var(--tw-bg-opacity, 1));
}
.bg-error-100\\/80 {
  background-color: rgb(254 201 203 / 0.8);
}
.bg-error-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 80 79 / var(--tw-bg-opacity, 1));
}
.bg-neutral-0 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-neutral-0\\/20 {
  background-color: rgb(255 255 255 / 0.2);
}
.bg-neutral-0\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.bg-neutral-0\\/85 {
  background-color: rgb(255 255 255 / 0.85);
}
.bg-neutral-0\\/95 {
  background-color: rgb(255 255 255 / 0.95);
}
.bg-neutral-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));
}
.bg-neutral-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 232 / var(--tw-bg-opacity, 1));
}
.bg-neutral-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(212 213 214 / var(--tw-bg-opacity, 1));
}
.bg-neutral-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(113 113 129 / var(--tw-bg-opacity, 1));
}
.bg-neutral-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(27 29 33 / var(--tw-bg-opacity, 1));
}
.bg-primary-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 244 207 / var(--tw-bg-opacity, 1));
}
.bg-primary-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 239 184 / var(--tw-bg-opacity, 1));
}
.bg-primary-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(201 228 131 / var(--tw-bg-opacity, 1));
}
.bg-primary-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(188 220 100 / var(--tw-bg-opacity, 1));
}
.bg-primary-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(171 201 91 / var(--tw-bg-opacity, 1));
}
.bg-primary-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(133 157 71 / var(--tw-bg-opacity, 1));
}
.bg-secondary-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(118 118 238 / var(--tw-bg-opacity, 1));
}
.bg-secondary-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 107 217 / var(--tw-bg-opacity, 1));
}
.bg-success-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(193 238 213 / var(--tw-bg-opacity, 1));
}
.bg-success-100\\/70 {
  background-color: rgb(193 238 213 / 0.7);
}
.bg-success-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(55 201 118 / var(--tw-bg-opacity, 1));
}
.bg-supportive1-500\\/40 {
  background-color: rgb(254 211 118 / 0.4);
}
.bg-supportive2-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(231 219 238 / var(--tw-bg-opacity, 1));
}
.bg-supportive5-500\\/20 {
  background-color: rgb(91 200 255 / 0.2);
}
.bg-supportive5-500\\/40 {
  background-color: rgb(91 200 255 / 0.4);
}
.bg-warning-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 221 192 / var(--tw-bg-opacity, 1));
}
.bg-warning-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 145 52 / var(--tw-bg-opacity, 1));
}
.bg-warning-500\\/10 {
  background-color: rgb(255 145 52 / 0.1);
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/40 {
  background-color: rgb(255 255 255 / 0.4);
}
.bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-\\[1\\.5px\\] {
  padding: 1.5px;
}
.p-\\[1px\\] {
  padding: 1px;
}
.p-\\[2px\\] {
  padding: 2px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[2px\\] {
  padding-left: 2px;
  padding-right: 2px;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.pb-11 {
  padding-bottom: 2.75rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-\\[125px\\] {
  padding-bottom: 125px;
}
.pb-\\[180px\\] {
  padding-bottom: 180px;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-11 {
  padding-top: 2.75rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-24 {
  padding-top: 6rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.pt-\\[30\\%\\] {
  padding-top: 30%;
}
.text-left {
  text-align: left;
}
.\\!text-center {
  text-align: center !important;
}
.text-center {
  text-align: center;
}
.text-start {
  text-align: start;
}
.\\!text-end {
  text-align: end !important;
}
.text-end {
  text-align: end;
}
.font-poppins {
  font-family: Poppins-Regular, Poppins-Bold, Poppins-SemiBold;
}
.font-yekan {
  font-family: YekanBakhFaNum-Regular, YekanBakhFaNum-Bold, YekanBakhFaNum-SemiBold;
}
.\\!text-\\[14px\\] {
  font-size: 14px !important;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.\\!font-light {
  font-weight: 300 !important;
}
.\\!font-semibold {
  font-weight: 600 !important;
}
.font-bold {
  font-weight: 700;
}
.\\!capitalize {
  text-transform: capitalize !important;
}
.ordinal {
  --tw-ordinal: ordinal;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-4 {
  line-height: 1rem;
}
.leading-tight {
  line-height: 1.25;
}
.\\!text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#F55F56\\] {
  --tw-text-opacity: 1;
  color: rgb(245 95 86 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-text-Primary600 {
  --tw-text-opacity: 1;
  color: rgb(171 201 91 / var(--tw-text-opacity, 1));
}
.text-text-Primary600-dark {
  --tw-text-opacity: 1;
  color: rgb(201 228 131 / var(--tw-text-opacity, 1));
}
.text-text-Success500 {
  --tw-text-opacity: 1;
  color: rgb(55 201 118 / var(--tw-text-opacity, 1));
}
.text-text-Success500-dark {
  --tw-text-opacity: 1;
  color: rgb(55 201 118 / var(--tw-text-opacity, 1));
}
.text-text-Success600 {
  --tw-text-opacity: 1;
  color: rgb(50 183 107 / var(--tw-text-opacity, 1));
}
.text-text-Success600-dark {
  --tw-text-opacity: 1;
  color: rgb(95 212 145 / var(--tw-text-opacity, 1));
}
.text-text-active {
  --tw-text-opacity: 1;
  color: rgb(188 220 100 / var(--tw-text-opacity, 1));
}
.text-text-active-dark {
  --tw-text-opacity: 1;
  color: rgb(138 193 79 / var(--tw-text-opacity, 1));
}
.text-text-base {
  --tw-text-opacity: 1;
  color: rgb(22 24 27 / var(--tw-text-opacity, 1));
}
.text-text-base-dark {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-text-button {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-text-button-dark {
  --tw-text-opacity: 1;
  color: rgb(22 24 27 / var(--tw-text-opacity, 1));
}
.text-text-error {
  --tw-text-opacity: 1;
  color: rgb(253 80 79 / var(--tw-text-opacity, 1));
}
.text-text-error-dark {
  --tw-text-opacity: 1;
  color: rgb(224 74 74 / var(--tw-text-opacity, 1));
}
.text-text-muted {
  --tw-text-opacity: 1;
  color: rgb(170 171 173 / var(--tw-text-opacity, 1));
}
.text-text-muted-dark {
  --tw-text-opacity: 1;
  color: rgb(77 77 80 / var(--tw-text-opacity, 1));
}
.text-text-secondary {
  --tw-text-opacity: 1;
  color: rgb(85 87 92 / var(--tw-text-opacity, 1));
}
.text-text-secondary-dark {
  --tw-text-opacity: 1;
  color: rgb(170 171 173 / var(--tw-text-opacity, 1));
}
.text-text-secondaryPurple {
  --tw-text-opacity: 1;
  color: rgb(118 118 238 / var(--tw-text-opacity, 1));
}
.text-text-secondaryPurple-dark {
  --tw-text-opacity: 1;
  color: rgb(118 118 238 / var(--tw-text-opacity, 1));
}
.text-text-success {
  --tw-text-opacity: 1;
  color: rgb(50 183 107 / var(--tw-text-opacity, 1));
}
.text-text-success-dark {
  --tw-text-opacity: 1;
  color: rgb(40 163 92 / var(--tw-text-opacity, 1));
}
.text-text-supportive1 {
  --tw-text-opacity: 1;
  color: rgb(254 211 118 / var(--tw-text-opacity, 1));
}
.text-text-supportive1-dark {
  --tw-text-opacity: 1;
  color: rgb(254 211 118 / var(--tw-text-opacity, 1));
}
.text-text-supportive2 {
  --tw-text-opacity: 1;
  color: rgb(178 139 201 / var(--tw-text-opacity, 1));
}
.text-text-supportive2-dark {
  --tw-text-opacity: 1;
  color: rgb(178 139 201 / var(--tw-text-opacity, 1));
}
.text-text-supportive3 {
  --tw-text-opacity: 1;
  color: rgb(255 74 116 / var(--tw-text-opacity, 1));
}
.text-text-supportive3-dark {
  --tw-text-opacity: 1;
  color: rgb(255 74 116 / var(--tw-text-opacity, 1));
}
.text-text-supportive4 {
  --tw-text-opacity: 1;
  color: rgb(19 39 214 / var(--tw-text-opacity, 1));
}
.text-text-supportive4-dark {
  --tw-text-opacity: 1;
  color: rgb(19 39 214 / var(--tw-text-opacity, 1));
}
.text-text-supportive5 {
  --tw-text-opacity: 1;
  color: rgb(91 200 255 / var(--tw-text-opacity, 1));
}
.text-text-supportive5-dark {
  --tw-text-opacity: 1;
  color: rgb(91 200 255 / var(--tw-text-opacity, 1));
}
.text-text-supportive6 {
  --tw-text-opacity: 1;
  color: rgb(13 231 170 / var(--tw-text-opacity, 1));
}
.text-text-supportive6-dark {
  --tw-text-opacity: 1;
  color: rgb(13 231 170 / var(--tw-text-opacity, 1));
}
.text-text-warning {
  --tw-text-opacity: 1;
  color: rgb(255 145 52 / var(--tw-text-opacity, 1));
}
.text-text-warning-dark {
  --tw-text-opacity: 1;
  color: rgb(255 122 26 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.line-through {
  text-decoration-line: line-through;
}
.\\!opacity-100 {
  opacity: 1 !important;
}
.\\!opacity-30 {
  opacity: 0.3 !important;
}
.opacity-35 {
  opacity: 0.35;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-45 {
  opacity: 0.45;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-90 {
  opacity: 0.9;
}
.shadow {
  --tw-shadow: 0px 1px 4px rgba(0, 0, 0, 0.35);
  --tw-shadow-colored: 0px 1px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0px 12px 38px rgba(0, 0, 0, 0.35) ;
  --tw-shadow-colored: 0px 12px 38px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-custom {
  --tw-shadow: 4px 4px 10px rgba(0,0,0,0.05);
  --tw-shadow-colored: 4px 4px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0px 4px 10px rgba(0, 0, 0, 0.35);
  --tw-shadow-colored: 0px 4px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0px 3px 10px rgba(0, 0, 0, 0.35);
  --tw-shadow-colored: 0px 3px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-xl {
  --tw-blur: blur(24px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-lg {
  --tw-drop-shadow: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04)) drop-shadow(0 4px 3px rgb(0 0 0 / 0.1));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-3xl {
  --tw-backdrop-blur: blur(64px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl {
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
/* Typography */
.title1 {
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 2rem;
}
@media (min-width: 1024px) {

  .title1 {
    font-size: 2rem;
    line-height: 2.5rem;
  }
}
.title2 {
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.5rem;
}
@media (min-width: 1024px) {

  .title2 {
    font-size: 1.75rem;
    line-height: 2rem;
  }
}
.title3 {
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.5rem;
}
@media (min-width: 1024px) {

  .title3 {
    font-size: 1.5rem;
    line-height: 2rem;
  }
}
.title4 {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25rem;
}
@media (min-width: 1024px) {

  .title4 {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.subtitle1 {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5rem;
}
@media (min-width: 1024px) {

  .subtitle1 {
    font-size: 1.25rem;
    line-height: 1.5rem;
  }
}
.subtitle2 {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25rem;
}
@media (min-width: 1024px) {

  .subtitle2 {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
.subtitle3 {
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1rem;
}
@media (min-width: 1024px) {

  .subtitle3 {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
.button1 {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25rem;
}
@media (min-width: 1024px) {

  .button1 {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.button2 {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25rem;
}
@media (min-width: 1024px) {

  .button2 {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
.body1 {
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.5rem;
}
@media (min-width: 1024px) {

  .body1 {
    font-size: 1.25rem;
    line-height: 1.5rem;
  }
}
.body2 {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5rem;
}
@media (min-width: 1024px) {

  .body2 {
    font-size: 1.125rem;
    line-height: 1.5rem;
  }
}
.body3 {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25rem;
}
@media (min-width: 1024px) {

  .body3 {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.caption {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
}
@media (min-width: 1024px) {

  .caption {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
.placeholder {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25rem;
}
@media (min-width: 1024px) {

  .placeholder {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.badge {
  font-size: 0.625rem;
  font-weight: 600;
  line-height: 0.75rem;
}
@media (min-width: 1024px) {

  .badge {
    font-size: 0.625rem;
    line-height: 0.75rem;
  }
}
.en_title1 {
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
}
@media (min-width: 1024px) {

  .en_title1 {
    font-size: 28px;
    line-height: 32px;
  }
}
.en_title2 {
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
}
@media (min-width: 1024px) {

  .en_title2 {
    font-size: 24px;
    line-height: 32px;
  }
}
.en_title3 {
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
}
@media (min-width: 1024px) {

  .en_title3 {
    font-size: 20px;
    line-height: 24px;
  }
}
.en_title4 {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}
@media (min-width: 1024px) {

  .en_title4 {
    font-size: 16px;
    line-height: 24px;
  }
}
.en_subtitle1 {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}
@media (min-width: 1024px) {

  .en_subtitle1 {
    font-size: 18px;
    line-height: 24px;
  }
}
.en_subtitle2 {
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
}
@media (min-width: 1024px) {

  .en_subtitle2 {
    font-size: 16px;
    line-height: 24px;
  }
}
.en_subtitle3 {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
}
@media (min-width: 1024px) {

  .en_subtitle3 {
    font-size: 14px;
    line-height: 20px;
  }
}
.en_button1 {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}
@media (min-width: 1024px) {

  .en_button1 {
    font-size: 16px;
    line-height: 24px;
  }
}
.en_button2 {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}
@media (min-width: 1024px) {

  .en_button2 {
    font-size: 14px;
    line-height: 20px;
  }
}
.en_body1 {
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
}
@media (min-width: 1024px) {

  .en_body1 {
    font-size: 20px;
    line-height: 24px;
  }
}
.en_body2 {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}
@media (min-width: 1024px) {

  .en_body2 {
    font-size: 18px;
    line-height: 24px;
  }
}
.en_body3 {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}
@media (min-width: 1024px) {

  .en_body3 {
    font-size: 16px;
    line-height: 24px;
  }
}
.en_caption {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}
@media (min-width: 1024px) {

  .en_caption {
    font-size: 14px;
    line-height: 20px;
  }
}
.en_placeholder {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}
@media (min-width: 1024px) {

  .en_placeholder {
    font-size: 16px;
    line-height: 24px;
  }
}
.en_badge {
  font-size: 10px;
  font-weight: 600;
  line-height: 12px;
}
@media (min-width: 1024px) {

  .en_badge {
    font-size: 10px;
    line-height: 12px;
  }
}
.ReactCollapse--collapse {
  transition: height 500ms;
}
.disabled\\:opacity-25:disabled {
  opacity: 0.25;
}
.web\\:fixed {
  position: fixed;
}
.web\\:-bottom-\\[130px\\] {
  bottom: -130px;
}
.web\\:-left-\\[20\\%\\] {
  left: -20%;
}
.web\\:-left-\\[24\\%\\] {
  left: -24%;
}
.web\\:-left-\\[30\\%\\] {
  left: -30%;
}
.web\\:-left-\\[34\\%\\] {
  left: -34%;
}
.web\\:-left-\\[38\\%\\] {
  left: -38%;
}
.web\\:-left-\\[40\\%\\] {
  left: -40%;
}
.web\\:-left-\\[6\\%\\] {
  left: -6%;
}
.web\\:-right-\\[15\\%\\] {
  right: -15%;
}
.web\\:-right-\\[35\\%\\] {
  right: -35%;
}
.web\\:-top-\\[20px\\] {
  top: -20px;
}
.web\\:-top-\\[70px\\] {
  top: -70px;
}
.web\\:bottom-24 {
  bottom: 6rem;
}
.web\\:bottom-4 {
  bottom: 1rem;
}
.web\\:left-0 {
  left: 0px;
}
.web\\:left-1\\/2 {
  left: 50%;
}
.web\\:h-\\[120px\\] {
  height: 120px;
}
.web\\:h-\\[80px\\] {
  height: 80px;
}
.web\\:-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.web\\:-rotate-\\[25deg\\] {
  --tw-rotate: -25deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.web\\:rotate-\\[10deg\\] {
  --tw-rotate: 10deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.web\\:justify-center {
  justify-content: center;
}
.web\\:overflow-hidden {
  overflow: hidden;
}
.web\\:pb-4 {
  padding-bottom: 1rem;
}
.web\\:pb-6 {
  padding-bottom: 1.5rem;
}
.web\\:pl-3 {
  padding-left: 0.75rem;
}
.web\\:pr-8 {
  padding-right: 2rem;
}
.web\\:pt-20 {
  padding-top: 5rem;
}
.web\\:pt-6 {
  padding-top: 1.5rem;
}
.web\\:pt-\\[100px\\] {
  padding-top: 100px;
}
.web\\:pt-\\[85px\\] {
  padding-top: 85px;
}
.web\\:pt-\\[90px\\] {
  padding-top: 90px;
}
.web\\:opacity-80 {
  opacity: 0.8;
}
.web\\:backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.dark\\:divide-neutral-dark-200:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(35 37 41 / var(--tw-divide-opacity, 1));
}
.dark\\:border-neutral-300:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(212 213 214 / var(--tw-border-opacity, 1));
}
.dark\\:border-neutral-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(42 45 51 / var(--tw-border-opacity, 1));
}
.dark\\:border-neutral-dark-100:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(27 29 33 / var(--tw-border-opacity, 1));
}
.dark\\:border-neutral-dark-200:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(35 37 41 / var(--tw-border-opacity, 1));
}
.dark\\:border-neutral-dark-300:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(42 45 51 / var(--tw-border-opacity, 1));
}
.dark\\:border-neutral-dark-400:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(85 87 92 / var(--tw-border-opacity, 1));
}
.dark\\:border-neutral-dark-400\\/40:is(.dark *) {
  border-color: rgb(85 87 92 / 0.4);
}
.dark\\:border-neutral-dark-400\\/50:is(.dark *) {
  border-color: rgb(85 87 92 / 0.5);
}
.dark\\:border-neutral-dark-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(212 213 214 / var(--tw-border-opacity, 1));
}
.dark\\:border-primary-500:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(188 220 100 / var(--tw-border-opacity, 1));
}
.dark\\:border-primary-dark-400:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(171 201 91 / var(--tw-border-opacity, 1));
}
.dark\\:border-white:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.dark\\:bg-\\[\\#24262C\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(36 38 44 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-bg-secondary-dark:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(35 37 41 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-error-dark-100:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(106 34 33 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-error-dark-100\\/80:is(.dark *) {
  background-color: rgb(106 34 33 / 0.8);
}
.dark\\:bg-neutral-800\\/50:is(.dark *) {
  background-color: rgb(35 37 41 / 0.5);
}
.dark\\:bg-neutral-dark-0:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(22 24 27 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-neutral-dark-100:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(27 29 33 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-neutral-dark-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(35 37 41 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-neutral-dark-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(42 45 51 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-neutral-dark-300\\/40:is(.dark *) {
  background-color: rgb(42 45 51 / 0.4);
}
.dark\\:bg-neutral-dark-300\\/80:is(.dark *) {
  background-color: rgb(42 45 51 / 0.8);
}
.dark\\:bg-neutral-dark-300\\/85:is(.dark *) {
  background-color: rgb(42 45 51 / 0.85);
}
.dark\\:bg-neutral-dark-300\\/90:is(.dark *) {
  background-color: rgb(42 45 51 / 0.9);
}
.dark\\:bg-neutral-dark-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-primary-dark-100:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(79 93 42 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-primary-dark-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(103 124 55 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-primary-dark-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(133 157 71 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-primary-dark-400:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(171 201 91 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-primary-dark-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(188 220 100 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-primary-dark-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(210 232 151 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-success-dark-100:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(23 84 50 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-success-dark-100\\/70:is(.dark *) {
  background-color: rgb(23 84 50 / 0.7);
}
.dark\\:bg-supportive2-dark-100:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 62 84 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-text-Primary600-dark:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(201 228 131 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-warning-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 181 119 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-warning-dark-100:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(107 61 22 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-white\\/20:is(.dark *) {
  background-color: rgb(255 255 255 / 0.2);
}
.dark\\:text-text-base-dark:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.dark\\:text-text-muted-dark:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(77 77 80 / var(--tw-text-opacity, 1));
}
.ltr\\:text-left:where([dir="ltr"], [dir="ltr"] *) {
  text-align: left;
}
.rtl\\:right-\\[20\\%\\]:where([dir="rtl"], [dir="rtl"] *) {
  right: 20%;
}
.rtl\\:right-\\[6\\%\\]:where([dir="rtl"], [dir="rtl"] *) {
  right: 6%;
}
.rtl\\:flex-row-reverse:where([dir="rtl"], [dir="rtl"] *) {
  flex-direction: row-reverse;
}
.rtl\\:justify-start:where([dir="rtl"], [dir="rtl"] *) {
  justify-content: flex-start;
}
.rtl\\:text-left:where([dir="rtl"], [dir="rtl"] *) {
  text-align: left;
}
.rtl\\:text-right:where([dir="rtl"], [dir="rtl"] *) {
  text-align: right;
}
`, "",{"version":3,"sources":["webpack://./global.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,kCAAc;EAAd,mBAAc;EAAd;AAAc;EAAd,wBAAc;EAAd;IAAA,8BAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,kBAAc;IAAd,4CAAc;EAAA;EAAd;IAAA,2BAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,kBAAc;IAAd,4CAAc;EAAA;EAAd;IAAA,+BAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,kBAAc;IAAd,4CAAc;EAAA;;EAAd,+BAAc;EAAd;IAAA,qCAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,kBAAc;IAAd,4CAAc;EAAA;EAAd;IAAA,kCAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,kBAAc;IAAd,4CAAc;EAAA;EAAd;IAAA,sCAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,kBAAc;IAAd,4CAAc;EAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAsDhB;EAAA,WAAgC;EAAhC,gBAAgC;EAAhC,qBAAgC;EAAhC;AAAgC;AAIhC;EAAA,YAAqI;EAArI,qBAAqI;EAArI,iBAAqI;EAArI,sBAAqI;EAArI,4DAAqI;EAArI,wCAAqI;EAArI,aAAqI;EAArI,0CAAqI;EAArI,wDAAqI;EAArI;AAAqI;AAArI;EAAA,sBAAqI;EAArI,yDAAqI;EAArI;AAAqI;AAGrI;EAAA,YAAmG;EAAnG,qBAAmG;EAAnG,iBAAmG;EAAnG,oCAAmG;EAAnG,wCAAmG;EAAnG,aAAmG;EAAnG,0CAAmG;EAAnG,wDAAmG;EAAnG;AAAmG;AAKrG,YAAY;AAEV;EAAA,iBAAsE;EAAtE,yBAAsE;EAAtE,kBAAsE;EAAtE;AAAsE;AAAtE;EAAA,kBAAsE;EAAtE;AAAsE;AAGtE;EAAA,iBAA8H;EAA9H,yBAA8H;EAA9H,kBAA8H;EAA9H;AAA8H;AAA9H;EAAA,kBAA8H;EAA9H;AAA8H;AAA9H;EAAA,kBAA8H;EAA9H;AAA8H;AAA9H;EAAA,kBAA8H;EAA9H;AAA8H;AAG9H;EAAA,iBAAwE;EAAxE,sBAAwE;EAAxE,4DAAwE;EAAxE;AAAwE;AAAxE;EAAA,sBAAwE;EAAxE;AAAwE;AAGxE;EAAA,iBAA+C;EAA/C,yBAA+C;EAA/C;AAA+C;AAGjD,UAAU;AAER;EAAA,iBAA+H;EAA/H,yBAA+H;EAA/H,kBAA+H;EAA/H;AAA+H;AAA/H;EAAA,kBAA+H;EAA/H;AAA+H;AAA/H;EAAA,kBAA+H;EAA/H;AAA+H;AAA/H;EAAA,kBAA+H;EAA/H;AAA+H;AAG/H;EAAA,iBAAmH;EAAnH,yBAAmH;EAAnH,kBAAmH;EAAnH;AAAmH;AAAnH;EAAA,kBAAmH;EAAnH;AAAmH;AAAnH;EAAA,kBAAmH;EAAnH;AAAmH;AAGnH;EAAA,iBAAmH;EAAnH,yBAAmH;EAAnH,kBAAmH;EAAnH;AAAmH;AAAnH;EAAA,kBAAmH;EAAnH;AAAmH;AAAnH;EAAA,kBAAmH;EAAnH;AAAmH;AAGnH;EAAA,iBAA+H;EAA/H,yBAA+H;EAA/H,kBAA+H;EAA/H;AAA+H;AAA/H;EAAA,kBAA+H;EAA/H;AAA+H;AAA/H;EAAA,kBAA+H;EAA/H;AAA+H;AAA/H;EAAA,kBAA+H;EAA/H;AAA+H;AAG/H;EAAA,iBAAwI;EAAxI,sBAAwI;EAAxI,yDAAwI;EAAxI;AAAwI;AAAxI;EAAA,sBAAwI;EAAxI;AAAwI;AAAxI;EAAA,sBAAwI;EAAxI;AAAwI;AAAxI;EAAA,sBAAwI;EAAxI;AAAwI;AAGxI;EAAA,iBAA+C;EAA/C,yBAA+C;EAA/C;AAA+C;AAGjD,YAAY;AAEV;EAAA,iBAAkH;EAAlH,yBAAkH;EAAlH,kBAAkH;EAAlH,2DAAkH;EAAlH,oBAAkH;EAAlH;AAAkH;AAAlH;EAAA,kBAAkH;EAAlH;AAAkH;AAAlH;EAAA,oBAAkH;EAAlH;AAAkH;AAGlH;EAAA,iBAA4H;EAA5H,yBAA4H;EAA5H,kBAA4H;EAA5H;AAA4H;AAA5H;EAAA,kBAA4H;EAA5H;AAA4H;AAA5H;EAAA,kBAA4H;EAA5H;AAA4H;AAA5H;EAAA,kBAA4H;EAA5H;AAA4H;AAG5H;EAAA,iBAAwE;EAAxE,sBAAwE;EAAxE,2DAAwE;EAAxE;AAAwE;AAAxE;EAAA,sBAAwE;EAAxE;AAAwE;AAGxE;EAAA,iBAA+C;EAA/C,yBAA+C;EAA/C;AAA+C;AAG/C;EAAA,WAAkJ;EAAlJ,gBAAkJ;EAAlJ,qBAAkJ;EAAlJ,iBAAkJ;EAAlJ,sBAAkJ;EAAlJ,4DAAkJ;EAAlJ,wCAAkJ;EAAlJ;AAAkJ;AAAlJ;EAAA,iCAAkJ;EAAlJ;AAAkJ;AAIlJ;EAAA,iBAAgF;EAAhF,sBAAgF;EAAhF,2DAAgF;EAAhF;AAAgF;AAAhF;EAAA,sBAAgF;EAAhF;AAAgF;AArHpF;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AA0HjB,eAAe;AAEb;EAAA,iBAAqF;EAArF,gBAAqF;EAArF;AAAqF;AAArF;;EAAA;IAAA,eAAqF;IAArF;EAAqF;AAAA;AAGrF;EAAA,kBAAoF;EAApF,gBAAoF;EAApF;AAAoF;AAApF;;EAAA;IAAA,kBAAoF;IAApF;EAAoF;AAAA;AAGpF;EAAA,mBAAoF;EAApF,gBAAoF;EAApF;AAAoF;AAApF;;EAAA;IAAA,iBAAoF;IAApF;EAAoF;AAAA;AAGpF;EAAA,mBAAyF;EAAzF,gBAAyF;EAAzF;AAAyF;AAAzF;;EAAA;IAAA,eAAyF;IAAzF;EAAyF;AAAA;AAGzF;EAAA,eAAuF;EAAvF,gBAAuF;EAAvF;AAAuF;AAAvF;;EAAA;IAAA,kBAAuF;IAAvF;EAAuF;AAAA;AAGvF;EAAA,mBAA8F;EAA9F,gBAA8F;EAA9F;AAA8F;AAA9F;;EAAA;IAAA,mBAA8F;IAA9F;EAA8F;AAAA;AAG9F;EAAA,kBAA0F;EAA1F,gBAA0F;EAA1F;AAA0F;AAA1F;;EAAA;IAAA,mBAA0F;IAA1F;EAA0F;AAAA;AAG1F;EAAA,mBAAyF;EAAzF,gBAAyF;EAAzF;AAAyF;AAAzF;;EAAA;IAAA,eAAyF;IAAzF;EAAyF;AAAA;AAGzF;EAAA,mBAA8F;EAA9F,gBAA8F;EAA9F;AAA8F;AAA9F;;EAAA;IAAA,mBAA8F;IAA9F;EAA8F;AAAA;AAG9F;EAAA,mBAA2F;EAA3F,gBAA2F;EAA3F;AAA2F;AAA3F;;EAAA;IAAA,kBAA2F;IAA3F;EAA2F;AAAA;AAG3F;EAAA,eAAwF;EAAxF,gBAAwF;EAAxF;AAAwF;AAAxF;;EAAA;IAAA,mBAAwF;IAAxF;EAAwF;AAAA;AAGxF;EAAA,mBAAyF;EAAzF,gBAAyF;EAAzF;AAAyF;AAAzF;;EAAA;IAAA,eAAyF;IAAzF;EAAyF;AAAA;AAGzF;EAAA,mBAA4F;EAA5F,gBAA4F;EAA5F;AAA4F;AAA5F;;EAAA;IAAA,mBAA4F;IAA5F;EAA4F;AAAA;AAG5F;EAAA,mBAAyF;EAAzF,gBAAyF;EAAzF;AAAyF;AAAzF;;EAAA;IAAA,eAAyF;IAAzF;EAAyF;AAAA;AAGzF;EAAA,mBAA8F;EAA9F,gBAA8F;EAA9F;AAA8F;AAA9F;;EAAA;IAAA,mBAA8F;IAA9F;EAA8F;AAAA;AAG9F;EAAA,eAA4E;EAA5E,gBAA4E;EAA5E;AAA4E;AAA5E;;EAAA;IAAA,eAA4E;IAA5E;EAA4E;AAAA;AAG5E;EAAA,eAA4E;EAA5E,gBAA4E;EAA5E;AAA4E;AAA5E;;EAAA;IAAA,eAA4E;IAA5E;EAA4E;AAAA;AAG5E;EAAA,eAA4E;EAA5E,gBAA4E;EAA5E;AAA4E;AAA5E;;EAAA;IAAA,eAA4E;IAA5E;EAA4E;AAAA;AAG5E;EAAA,eAAgF;EAAhF,gBAAgF;EAAhF;AAAgF;AAAhF;;EAAA;IAAA,eAAgF;IAAhF;EAAgF;AAAA;AAGhF;EAAA,eAA8E;EAA9E,gBAA8E;EAA9E;AAA8E;AAA9E;;EAAA;IAAA,eAA8E;IAA9E;EAA8E;AAAA;AAG9E;EAAA,eAA8E;EAA9E,gBAA8E;EAA9E;AAA8E;AAA9E;;EAAA;IAAA,eAA8E;IAA9E;EAA8E;AAAA;AAG9E;EAAA,eAA8E;EAA9E,gBAA8E;EAA9E;AAA8E;AAA9E;;EAAA;IAAA,eAA8E;IAA9E;EAA8E;AAAA;AAG9E;EAAA,eAAgF;EAAhF,gBAAgF;EAAhF;AAAgF;AAAhF;;EAAA;IAAA,eAAgF;IAAhF;EAAgF;AAAA;AAGhF;EAAA,eAAgF;EAAhF,gBAAgF;EAAhF;AAAgF;AAAhF;;EAAA;IAAA,eAAgF;IAAhF;EAAgF;AAAA;AAGhF;EAAA,eAA8E;EAA9E,gBAA8E;EAA9E;AAA8E;AAA9E;;EAAA;IAAA,eAA8E;IAA9E;EAA8E;AAAA;AAG9E;EAAA,eAA8E;EAA9E,gBAA8E;EAA9E;AAA8E;AAA9E;;EAAA;IAAA,eAA8E;IAA9E;EAA8E;AAAA;AAG9E;EAAA,eAA8E;EAA9E,gBAA8E;EAA9E;AAA8E;AAA9E;;EAAA;IAAA,eAA8E;IAA9E;EAA8E;AAAA;AAG9E;EAAA,eAA8E;EAA9E,gBAA8E;EAA9E;AAA8E;AAA9E;;EAAA;IAAA,eAA8E;IAA9E;EAA8E;AAAA;AAG9E;EAAA,eAAgF;EAAhF,gBAAgF;EAAhF;AAAgF;AAAhF;;EAAA;IAAA,eAAgF;IAAhF;EAAgF;AAAA;AAGhF;EAAA,eAAgF;EAAhF,gBAAgF;EAAhF;AAAgF;AAAhF;;EAAA;IAAA,eAAgF;IAAhF;EAAgF;AAAA;AAlNpF;EACE,wBAAwB;AAC1B;AALA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA,sBAwNA;EAxNA;AAwNA;AAxNA;EAAA,mBAwNA;EAxNA;AAwNA;AAxNA;EAAA,kBAwNA;EAxNA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA,6BAwNA;EAxNA;AAwNA;AAxNA;EAAA,sBAwNA;EAxNA;AAwNA;AAxNA;EAAA,sBAwNA;EAxNA;AAwNA;AAxNA;EAAA,sBAwNA;EAxNA;AAwNA;AAxNA;EAAA,sBAwNA;EAxNA;AAwNA;AAxNA;EAAA,sBAwNA;EAxNA;AAwNA;AAxNA;EAAA,sBAwNA;EAxNA;AAwNA;AAxNA;EAAA,sBAwNA;EAxNA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA,sBAwNA;EAxNA;AAwNA;AAxNA;EAAA,sBAwNA;EAxNA;AAwNA;AAxNA;EAAA,sBAwNA;EAxNA;AAwNA;AAxNA;EAAA,sBAwNA;EAxNA;AAwNA;AAxNA;EAAA,kBAwNA;EAxNA;AAwNA;AAxNA;EAAA,kBAwNA;EAxNA;AAwNA;AAxNA;EAAA,kBAwNA;EAxNA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA,kBAwNA;EAxNA;AAwNA;AAxNA;EAAA,kBAwNA;EAxNA;AAwNA;AAxNA;EAAA,kBAwNA;EAxNA;AAwNA;AAxNA;EAAA,kBAwNA;EAxNA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA,kBAwNA;EAxNA;AAwNA;AAxNA;EAAA,kBAwNA;EAxNA;AAwNA;AAxNA;EAAA,kBAwNA;EAxNA;AAwNA;AAxNA;EAAA,kBAwNA;EAxNA;AAwNA;AAxNA;EAAA,kBAwNA;EAxNA;AAwNA;AAxNA;EAAA,kBAwNA;EAxNA;AAwNA;AAxNA;EAAA,kBAwNA;EAxNA;AAwNA;AAxNA;EAAA,kBAwNA;EAxNA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA,kBAwNA;EAxNA;AAwNA;AAxNA;EAAA,kBAwNA;EAxNA;AAwNA;AAxNA;EAAA,kBAwNA;EAxNA;AAwNA;AAxNA;EAAA,kBAwNA;EAxNA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA,oBAwNA;EAxNA;AAwNA;AAxNA;EAAA,oBAwNA;EAxNA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA;AAxNA;EAAA;AAwNA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n.ReactCollapse--collapse {\n  transition: height 500ms;\n}\n@layer base {\n  /* Poppins Font Family */\n  @font-face {\n    font-family: 'Poppins-Regular';\n    font-style: normal;\n    font-weight: 400;\n    font-display: swap;\n    src: url('./src/assets/font/Poppins-Regular.woff2');\n  }\n  @font-face {\n    font-family: 'Poppins-Bold';\n    font-style: normal;\n    font-weight: 700;\n    font-display: swap;\n    src: url('./src/assets/font/Poppins-Bold.woff2');\n  }\n  @font-face {\n    font-family: 'Poppins-SemiBold';\n    font-style: normal;\n    font-weight: 600;\n    font-display: swap;\n    src: url('./src/assets/font/Poppins-SemiBold.woff2');\n  }\n\n  /* YekanBakhFaNum Font Family */\n  @font-face {\n    font-family: 'YekanBakhFaNum-Regular';\n    font-style: normal;\n    font-weight: 400;\n    font-display: swap;\n    src: url('./src/assets/font/YekanBakhFaNum-Regular.woff2');\n  }\n  @font-face {\n    font-family: 'YekanBakhFaNum-Bold';\n    font-style: normal;\n    font-weight: 700;\n    font-display: swap;\n    src: url('./src/assets/font/YekanBakhFaNum-Bold.woff2');\n  }\n  @font-face {\n    font-family: 'YekanBakhFaNum-SemiBold';\n    font-style: normal;\n    font-weight: 600;\n    font-display: swap;\n    src: url('./src/assets/font/YekanBakhFaNum-SemiBold.woff2');\n  }\n}\n@layer components {\n  .Container {\n    @apply px-5 w-full max-w-[450px];\n  }\n\n  .CardBase {\n    @apply p-4 rounded-3xl  gap-3 bg-white/40 dark:bg-neutral-dark-300/40 shadow-custom  border border-white dark:border-neutral-dark-300;\n  }\n  .GiftCard {\n    @apply p-4 rounded-3xl gap-3 bg-supportive2-500/20  shadow-custom  border border-supportive2-500/60;\n  }\n  .bottomsheet {\n    @apply p-4 rounded-3xl gap-3 bg-[#F8F8F9] dark:bg-[#24262C] shadow-custom  border border-white dark:border-neutral-dark-300;\n  }\n  /* Primary */\n  .Fill-Primary {\n    @apply bg-primary-500 hover:bg-primary-400 border-2 border-transparent;\n  }\n  .Tonal-Primary {\n    @apply bg-primary-200 dark:bg-primary-dark-200 hover:bg-primary-100 dark:hover:bg-primary-dark-100 border-2 border-transparent;\n  }\n  .Outline-Primary {\n    @apply bg-transparent border border-primary-500 hover:border-primary-400;\n  }\n  .TextButton-Primary {\n    @apply bg-transparent border border-transparent;\n  }\n\n  /* Black */\n  .Fill-Black {\n    @apply bg-neutral-900  hover:bg-neutral-800 dark:bg-neutral-dark-900 hover:dark:bg-neutral-dark-800 border-2 border-transparent;\n  }\n  .Fill-Supportive1-Yellow {\n    @apply bg-supportive1-500  hover:bg-supportive1-400  hover:dark:bg-supportive1-dark-400 border-2 border-transparent;\n  }\n  .Fill-Supportive5-Blue {\n    @apply bg-supportive5-500  hover:bg-supportive5-400  hover:dark:bg-supportive5-dark-400 border-2 border-transparent;\n  }\n  .Tonal-Black {\n    @apply bg-neutral-200  hover:bg-neutral-100 dark:bg-neutral-dark-200 hover:dark:bg-neutral-dark-100 border-2 border-transparent;\n  }\n  .Outline-Black {\n    @apply bg-transparent border border-neutral-900 dark:border-neutral-dark-900 hover:border-neutral-800 hover:dark:border-neutral-dark-800;\n  }\n  .TextButton-Black {\n    @apply bg-transparent border border-transparent;\n  }\n\n  /* Success */\n  .Fill-Success {\n    @apply bg-success-500 hover:bg-success-400 border-2 border-transparent text-text-button dark:text-text-button-dark;\n  }\n  .Tonal-Success {\n    @apply bg-success-100 dark:bg-success-dark-100 hover:bg-success-50 dark:hover:bg-success-dark-50 border-2 border-transparent;\n  }\n  .Outline-Success {\n    @apply bg-transparent border border-success-500 hover:border-success-400;\n  }\n  .TextButton-Success {\n    @apply bg-transparent border border-transparent;\n  }\n  .BaseServiceCard {\n    @apply dark:bg-neutral-dark-300/50 bg-neutral-0/50  w-full  p-4 rounded-3xl  border border-neutral-0 dark:border-neutral-dark-400/50 min-w-[320px];\n  }\n\n  .Outline-Supportive5-Blue {\n    @apply bg-transparent border border-supportive5-500 hover:border-supportive5-400;\n  }\n}\n\n@layer utilities {\n  /* Typography */\n  .title1 {\n    @apply font-semibold  leading-[2rem] text-[1.5rem] lg:leading-[2.5rem] lg:text-[2rem];\n  }\n  .title2 {\n    @apply font-bold leading-[1.5rem] text-[1.25rem] lg:leading-[2rem] lg:text-[1.75rem];\n  }\n  .title3 {\n    @apply font-bold leading-[1.5rem] text-[1.125rem] lg:leading-[2rem] lg:text-[1.5rem];\n  }\n  .title4 {\n    @apply font-semibold leading-[1.25rem] text-[0.875rem] lg:leading-[1.5rem] lg:text-[1rem];\n  }\n  .subtitle1 {\n    @apply font-semibold leading-[1.5rem] text-[1rem] lg:leading-[1.5rem] lg:text-[1.25rem];\n  }\n  .subtitle2 {\n    @apply font-semibold leading-[1.25rem] text-[0.875rem] lg:leading-[1.25rem] lg:text-[0.875rem];\n  }\n  .subtitle3 {\n    @apply font-semibold leading-[1rem] text-[0.75rem] lg:leading-[1.25rem] lg:text-[0.875rem];\n  }\n  .button1 {\n    @apply font-semibold leading-[1.25rem] text-[0.875rem] lg:leading-[1.5rem] lg:text-[1rem];\n  }\n  .button2 {\n    @apply font-semibold leading-[1.25rem] text-[0.875rem] lg:leading-[1.25rem] lg:text-[0.875rem];\n  }\n  .body1 {\n    @apply font-semibold leading-[1.5rem] text-[1.125rem] lg:leading-[1.5rem] lg:text-[1.25rem];\n  }\n  .body2 {\n    @apply font-semibold leading-[1.5rem] text-[1rem] lg:leading-[1.5rem] lg:text-[1.125rem];\n  }\n  .body3 {\n    @apply font-semibold leading-[1.25rem] text-[0.875rem] lg:leading-[1.5rem] lg:text-[1rem];\n  }\n  .caption {\n    @apply font-normal leading-[1.25rem] text-[0.875rem] lg:leading-[1.25rem] lg:text-[0.875rem];\n  }\n  .placeholder {\n    @apply font-semibold leading-[1.25rem] text-[0.875rem] lg:leading-[1.5rem] lg:text-[1rem];\n  }\n  .badge {\n    @apply font-semibold leading-[0.75rem] text-[0.625rem] lg:leading-[0.75rem] lg:text-[0.625rem];\n  }\n  .en_title1 {\n    @apply font-bold leading-[24px] text-[20px] lg:leading-[32px] lg:text-[28px];\n  }\n  .en_title2 {\n    @apply font-bold leading-[24px] text-[18px] lg:leading-[32px] lg:text-[24px];\n  }\n  .en_title3 {\n    @apply font-bold leading-[24px] text-[16px] lg:leading-[24px] lg:text-[20px];\n  }\n  .en_title4 {\n    @apply font-semibold leading-[20px] text-[14px] lg:leading-[24px] lg:text-[16px];\n  }\n  .en_subtitle1 {\n    @apply font-medium leading-[24px] text-[16px] lg:leading-[24px] lg:text-[18px];\n  }\n  .en_subtitle2 {\n    @apply font-medium leading-[24px] text-[14px] lg:leading-[24px] lg:text-[16px];\n  }\n  .en_subtitle3 {\n    @apply font-medium leading-[16px] text-[12px] lg:leading-[20px] lg:text-[14px];\n  }\n  .en_button1 {\n    @apply font-semibold leading-[20px] text-[14px] lg:leading-[24px] lg:text-[16px];\n  }\n  .en_button2 {\n    @apply font-semibold leading-[20px] text-[14px] lg:leading-[20px] lg:text-[14px];\n  }\n  .en_body1 {\n    @apply font-medium leading-[24px] text-[18px] lg:leading-[24px] lg:text-[20px];\n  }\n  .en_body2 {\n    @apply font-medium leading-[24px] text-[16px] lg:leading-[24px] lg:text-[18px];\n  }\n  .en_body3 {\n    @apply font-medium leading-[20px] text-[14px] lg:leading-[24px] lg:text-[16px];\n  }\n  .en_caption {\n    @apply font-medium leading-[20px] text-[14px] lg:leading-[20px] lg:text-[14px];\n  }\n  .en_placeholder {\n    @apply font-semibold leading-[20px] text-[14px] lg:leading-[24px] lg:text-[16px];\n  }\n  .en_badge {\n    @apply font-semibold leading-[12px] text-[10px] lg:leading-[12px] lg:text-[10px];\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
